import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: yup
          .string()
          .typeError(errors.REQUIRED)
          .required(errors.REQUIRED)
          .matches(REGEX_EXPS.zipCode, {
            message: errors.INVALID_VALUE,
            excludeEmptyString: true,
          }),
      }),
      [CONTACT_POINT_SYSTEM.CITY]: yup.object().shape({
        value: yup
          .string()
          .typeError(errors.REQUIRED)
          .required(errors.REQUIRED),
      }),
    }),
  });
};

export default validation;
